module.exports = __webpack_public_path__ + "img/NI.727c388b.png";